function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6689 14.0423V4.56806H18.7658V8.96513H14.0176H13.6664V9.31633V16.9655C13.6664 18.6391 12.2915 20.014 10.6179 20.014C8.94437 20.014 7.56947 18.6391 7.56947 16.9655C7.56947 15.292 8.94437 13.9171 10.6179 13.9171C11.1688 13.9171 11.6841 14.0779 12.1401 14.3453L12.6689 14.6554V14.0423ZM14.0176 5.56548H13.6664V5.91668V7.61651V7.96771H14.0176H17.4172H17.7684V7.61651V5.91668V5.56548H17.4172H14.0176ZM12.6689 16.9655C12.6689 15.8227 11.7607 14.9145 10.6179 14.9145C9.47509 14.9145 8.56688 15.8227 8.56688 16.9655C8.56688 18.1084 9.47509 19.0166 10.6179 19.0166C11.7607 19.0166 12.6689 18.1084 12.6689 16.9655Z",
  fill: "#777777",
  stroke: "#777777",
  strokeWidth: 0.702407
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 5.03315,
  x2: 10.68,
  y2: 5.03315,
  stroke: "#777777",
  strokeWidth: 1.61339
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 7.46881,
  y1: 2,
  x2: 7.46881,
  y2: 8.68,
  stroke: "#777777",
  strokeWidth: 1.61339
});

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.083b79634ccb284f7fc6ff097b6ec38e99d82a3687c11a918ceafe91d3e21ceb.svg";
export { ForwardRef as ReactComponent };